// extracted by mini-css-extract-plugin
export default {"formContainer":"AuthMethodForm_formContainer__noVnF"};